
<div class="flex-column flex-one full-height">
  <div class="container">
    <p class="text"> It appears another instance of the collaboration portal is using your user credentials. </p>
    <p class="text"> Concurrent access is not allowed </p>
    <button class="btn" (click)="onRetryClick()">Retry</button>
  </div>
</div>

